"use client";
import { Component, type ReactNode } from "react";

// A rejected lazy chunk is cached until reload. Keep the rest of the form
// editable and offer reload/email guidance instead of losing it to route error UI.
export default class AltchaLoadBoundary extends Component<
  { children: ReactNode; onError: () => void },
  { failed: boolean }
> {
  state = { failed: false };

  static getDerivedStateFromError() {
    return { failed: true };
  }

  componentDidCatch() {
    this.props.onError();
  }

  render() {
    return this.state.failed ? null : this.props.children;
  }
}
